export default __webpack_public_path__ + "static/media/Distribution of Attacks Among Information & Communication.ec430e60.PNG";